// extracted by mini-css-extract-plugin
export default {"faded":"resolveClassName_faded__8I5CR","fadeTransition":"resolveClassName_fadeTransition__ZyZ1C","notFaded":"resolveClassName_notFaded__pkeCh"};